type RouteDefinition = {
    route: string;
    params?: Record<string, string>;
};

export const AUTH_PASSWORD_RECOVERY_URL = '/password-recovery';
export const AUTH_URL = '/auth';

export const BASE_URL = "/login"

export const getUrl = (url: string) => {
    return BASE_URL + url;
}

export const zitadelRoutes = Object.freeze({
    LANDING: {
        route: "/landing",
        params: {
            ID: "id",
            TOKEN: "token",
            BACK_URL: "back-url",
            IS_REDIRECT_DISABLED: "no-redirect",
            RESOLUTION_TYPE: "resolution",
        },
    },
    MFA_INITIALISATION: {
        route: "/mfa-initialise",
    },
    TOTP_CHALLENGE: {
        route: "/totp",
    },
    OTP_EMAIL_CHALLENGE: {
        route: "/otp-email",
    },
} as const satisfies Record<string, RouteDefinition>);
